module.exports = __webpack_public_path__ + "img/icon-dimand.a9ec80fc.png";